var messages = {
  currentDate: '現在の日付'
};
export default messages;